import { render, staticRenderFns } from "./SupplierRawMaterialPalmOilDerivatives.vue?vue&type=template&id=3ba5b394&scoped=true"
import script from "./SupplierRawMaterialPalmOilDerivatives.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialPalmOilDerivatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5b394",
  null
  
)

export default component.exports